var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep1Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10483",
    "data-name": "Group 10483",
    transform: "translate(-590 -513.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2906",
    "data-name": "Ellipse 2906",
    transform: "translate(590 513.751)",
    fill: "#f2efef",
    stroke: "#7e59d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    strokeDasharray: "4 3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_48_",
    "data-name": "svgexport-6 (48)",
    transform: "translate(596.96 520.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10482",
    "data-name": "Group 10482",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10480",
    "data-name": "Group 10480",
    transform: "translate(0.142 0.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10667",
    "data-name": "Path 10667",
    d: "M108.667,16.791c-.211.024-.417.041-.615.052a11.982,11.982,0,0,1-2.083-.052c-.118-2.978,0-5.558,0-5.558a11.327,11.327,0,0,1-1.673,1.279,5.965,5.965,0,0,1-1.3-2.227,39.065,39.065,0,0,1,2.971-2.763s1.05-.057,2.081-.029c.208.006.416.015.614.029,0,0,.247,4.389,0,9.269Z",
    transform: "translate(-103.002 -7.485)",
    fill: "#eff4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10668",
    "data-name": "Path 10668",
    d: "M371.2,17.2c-.211.024-.417.041-.615.052.206-4.438.044-8.452,0-9.35.208.006.416.015.614.029C371.2,7.931,371.444,12.319,371.2,17.2Z",
    transform: "translate(-365.532 -7.894)",
    fill: "#daeaef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10669",
    "data-name": "Path 10669",
    d: "M141.956,37.505c-.186-.006-.375-.009-.558-.01-.577,0-1.108.015-1.378.027-1.143.964-2.107,1.914-2.537,2.35a5.637,5.637,0,0,0,.752,1.337c.8-.557,2.135-1.791,2.135-1.791s-.107,3.593-.022,6.3c.266.017.63.032,1.049.023.177,0,.365-.011.559-.024C142.117,42.065,142.009,38.74,141.956,37.505Z",
    transform: "translate(-136.832 -36.929)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10670",
    "data-name": "Path 10670",
    d: "M345.4,45.731c-.194.013-.382.021-.559.024.144-3.6.056-6.835,0-8.244.184,0,.372,0,.558.01C345.455,38.755,345.563,42.08,345.4,45.731Z",
    transform: "translate(-340.279 -36.944)",
    fill: "#7e59d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10481",
    "data-name": "Group 10481",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10671",
    "data-name": "Path 10671",
    d: "M101.363,56.484a.142.142,0,0,0-.147.136c-.012.327-.026.654-.042.973a12.47,12.47,0,0,1-2.426,0c-.109-2.886.008-5.4.009-5.424a.142.142,0,0,0-.238-.11,11.457,11.457,0,0,1-1.553,1.2A5.941,5.941,0,0,1,95.8,51.252c.2-.21.925-.946,1.877-1.8a.142.142,0,1,0-.189-.21c-1.132,1.02-1.942,1.87-1.95,1.879a.142.142,0,0,0-.034.136A6.054,6.054,0,0,0,96.84,53.54a.142.142,0,0,0,.175.024,11.308,11.308,0,0,0,1.445-1.071c-.028.8-.083,2.9.009,5.234a.142.142,0,0,0,.122.135,11.038,11.038,0,0,0,1.359.076,12.334,12.334,0,0,0,1.375-.075.142.142,0,0,0,.125-.134c.018-.359.034-.728.048-1.1A.142.142,0,0,0,101.363,56.484Z",
    transform: "translate(-95.503 -48.274)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10672",
    "data-name": "Path 10672",
    d: "M399.62,96.218a.142.142,0,0,0-.283.008c.038,1.341.069,3.426,0,5.745a.142.142,0,0,0,.137.146h0a.142.142,0,0,0,.141-.137C399.689,99.653,399.658,97.562,399.62,96.218Z",
    transform: "translate(-393.603 -94.267)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10673",
    "data-name": "Path 10673",
    d: "M223.5.761c.175-.152.35-.3.521-.445.253-.012,1.486-.066,2.505-.006.009.179.026.542.043,1.046a.142.142,0,0,0,.141.137h.005a.142.142,0,0,0,.137-.146C226.827.611,226.8.174,226.8.17a.142.142,0,0,0-.131-.133,26.576,26.576,0,0,0-2.712,0,.142.142,0,0,0-.083.033c-.184.153-.373.314-.562.479a.142.142,0,1,0,.186.214Z",
    transform: "translate(-220.854 0)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10674",
    "data-name": "Path 10674",
    d: "M132.966,34.364h0a.142.142,0,0,0-.142.14c-.017,1.507-.008,2.8.025,3.848a.142.142,0,0,0,.132.137c.21.014.488.026.81.026.249,0,.525-.007.817-.027a.142.142,0,0,0,.132-.135c.161-3.646.054-6.964,0-8.222A.142.142,0,0,0,134.6,30c-.759-.025-1.545,0-1.946.017a.141.141,0,0,0-.085.033c-1.131.953-2.081,1.887-2.547,2.359a.141.141,0,0,0-.031.152,5.749,5.749,0,0,0,.772,1.371.142.142,0,0,0,.193.03,24.547,24.547,0,0,0,1.9-1.579c-.008.319-.02.845-.03,1.483a.142.142,0,1,0,.283,0c.016-1.054.038-1.8.038-1.811a.142.142,0,0,0-.237-.108c-.013.012-1.221,1.124-2.008,1.7a5.5,5.5,0,0,1-.616-1.108c.477-.48,1.37-1.351,2.425-2.244.328-.013,1.044-.036,1.746-.019.054,1.326.147,4.474,0,7.939a12.252,12.252,0,0,1-1.335,0c-.029-1.019-.036-2.265-.021-3.707A.142.142,0,0,0,132.966,34.364Z",
    transform: "translate(-129.333 -29.419)",
    fill: "#2a2a2a"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Icon);
export default __webpack_public_path__ + "static/media/step1-icon.0dd11cb809459ed833091d7af4c5d321.svg";
export { ForwardRef as ReactComponent };